<template>
  <div class="">
    <div class="upload-button-container mb-1">
      <b-button
       v-if="!isCommandExecuted"
        variant="primary"
        size="sm"
        :disabled="disabled || isBtnDisabled || !facilityId || !formId"
        class="upload-button"
        @click="onClick"
      >
        <span v-if="!isCommandLoadig">{{ $t("action_plan.viewer.execute_command") }} {{ getNameOfCommand() }}</span>
        <b-spinner v-else small></b-spinner>
      </b-button>
      <span class="text-success" v-else>
        <feather-icon icon="CheckCircleIcon" size="18" class="mr-25"/>
        {{ $t("operational_security.evaluation.command_executed") }}
      </span>
    </div>
    <div class="d-flex flex-column">
      <span class="text-warning" v-if="!facilityId">
        <feather-icon icon="AlertTriangleIcon" size="18" class="mr-25"/>
        {{ $t("operational_security.select_facility_to_enable_command") }}
      </span>
      <span class="text-warning" v-if="!formId">
        <feather-icon icon="AlertTriangleIcon" size="18" class="mr-25"/>
        {{ $t("operational_security.form_id_to_enable_command") }}
      </span>
    </div>
    <div class="d-flex flex-column">
      <span class="text-error" v-if="error">{{ error }}</span>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch, computed } from "@vue/composition-api";
import { BSpinner } from 'bootstrap-vue'
import axios from "@axios";

export default {
  components: {
    BSpinner,
  },
  props: {
    id: String,
    name: String,
    label: String,
    fieldOptions: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    lastFacilitySelected: {
      type: Object,
      default: () => ({}),
    },
    field: {
      type: Object,
      default: () => ({}),
    },
    isFormDisabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const isCommandExecuted = ref(false);
    const isCommandLoadig = ref(false);
    const isBtnDisabled = ref(false);
    const error = ref(null);
    const facilityId = computed(() => {
      return props?.lastFacilitySelected?.facility?.value
    });
    const formId = computed(() => {
      return props?.fieldOptions?.formId
    });

    onMounted(() => {
      isBtnDisabled.value = props.isFormDisabled ?? false;
      // isCommandExecuted.value = props?.context?.model ? true : false
    });

    watch(
      () => props.isFormDisabled,
      (newValue, oldValue) => {
        isBtnDisabled.value = props.isFormDisabled;
      },
      { immediate: true }
    );

    watch(
      () => props.errors,
      (newValue, oldValue) => {
        error.value = props.errors[props.field.originalName] || null;
      },
      { immediate: true }
    );

    function getNameOfCommand() {
      return props?.field?.options?.fieldTypeCfg?.data[0]?.name || ''
    }

    async function onClick() {
      isCommandLoadig.value = true;
      const commandId = props?.field?.options?.fieldTypeCfg?.data[0]?.id
      const commandName = props?.field?.options?.fieldTypeCfg?.data[0]?.name
      const payload = {
        id_form: formId.value,
        id_facility: facilityId.value,
      }
      await axios.post(`v1/form-actions/${commandId}`, {payload});
      emit("updateData", props.field, commandName);
      isCommandExecuted.value = true;
      isCommandLoadig.value = false;
    }

    return {
      isCommandExecuted,
      isCommandLoadig,
      isBtnDisabled,
      facilityId,
      formId,
      error,
      getNameOfCommand,
      onClick
    }
  }
}
</script>
<style scoped>
.text-error {
  color: #ec0303;
}
</style>
